import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';

export type UpdateZoneamentoExecutionMode = 'INCREMENTAL' | 'FULL';

/**
 * RF004 — Dialog de confirmação para execução de atualização da base ZARC.
 *
 * Retorna o modo selecionado ('INCREMENTAL' | 'FULL') ao fechar com confirmação,
 * ou `undefined` se o usuário cancelar.
 */
@Component({
  selector: 'app-update-zoneamento-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatDialogContent,
    MatDialogTitle,
    MatDividerModule,
    MatIconModule,
    MatRadioModule,
  ],
  templateUrl: './update-zoneamento-dialog.component.html',
  styleUrl: './update-zoneamento-dialog.component.scss',
})
export class UpdateZoneamentoDialogComponent {
  readonly dialogRef = inject<
    MatDialogRef<UpdateZoneamentoDialogComponent, UpdateZoneamentoExecutionMode>
  >(
    MatDialogRef<
      UpdateZoneamentoDialogComponent,
      UpdateZoneamentoExecutionMode
    >,
  );

  readonly executionMode = signal<UpdateZoneamentoExecutionMode>('INCREMENTAL');

  confirm(): void {
    this.dialogRef.close(this.executionMode());
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
